/* eslint-disable @next/next/no-html-link-for-pages */
import { Box } from "@chakra-ui/react";
import BaseLayout from "../../../components/en/index_layout";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState, useEffect } from "react";
import { GetCookie } from "../../../provider/common";

export default function SellerExplain() {
  const router = useRouter();
  const [isLogin, setIsLogin] = useState(false);

  const moveMarketPlace = async () => {
    router.push("/en");
    return;
  };

  useEffect(() => {
    const checkLoginStatus = async () => {
      const isLogin = await GetCookie("isLogin");
      setIsLogin(Number(isLogin));
    };
    checkLoginStatus();
  }, []);

  return (
    <BaseLayout>
      <Box
        style={{
          width: "100%",
          height: "100%",
          maxWidth: "1100px",
          margin: "0 auto 30px",
        }}
      >
        <Box
          style={{
            width: "100%",
            height: "160px",
            position: "relative",
            // backgroundColor: "#202e46",
            background:
              "url(../../images/en/marketplace_pc_banner.jpg) no-repeat 50% 54%",
            backgroundSize: "contain",
          }}
        >
          <Box
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              top: "0",
              left: "0",
              background:
                "url(../images/banner/banner_21.png) no-repeat 50% 54%",
              backgroundSize: "contain",
            }}
          ></Box>
        </Box>
        <Box
          style={{
            margin: "3% 0 5%",
          }}
        >
          <h1
            style={{
              fontSize: "36px",
              fontWeight: "500",
              marginBottom: "20px",
              letterSpacing: "-0.5px",
            }}
          >
            Manage My RFQ
          </h1>
          <p style={{ fontSize: "18px" }}>
            * You can create and manage RFQ for your sourcing requirements and
            receive quotes from the marketplace.
          </p>
        </Box>
        <Box
          style={{
            borderTop: "1px solid rgb(20, 24, 31)",
          }}
        >
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>My RFQ</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * Once RFQs are created, verified suppliers may respond to your
              request and submit quotes. <br />
              To view quotes you've received, go to the
              <a
                href={
                  isLogin === 1
                    ? "/en/estimate/lists"
                    : "/en/auth/login?before=/en/estimate/lists"
                }
                style={{ color: "rgb(44, 47, 242)", marginLeft: "3.5px" }}
              >
                My RFQ page.
              </a>
            </p>
          </Box>
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}>Create RFQ </h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * You can create your RFQ and receive quotes from verified
              suppliers on the platform.{" "}
              <a
                href={
                  isLogin === 1
                    ? "/en/estimate/request?type=manual"
                    : "/en/auth/login?before=/en/estimate/request?type=manual"
                }
                style={{ color: "rgb(44, 47, 242)" }}
              >
                Get started now.
              </a>
            </p>
          </Box>
          <Box
            style={{
              borderBottom: "1px solid rgb(216, 219, 222)",
              padding: "32px 0",
            }}
          >
            <h3 style={{ fontSize: "20px" }}> RFQ Cart</h3>
            <p
              style={{
                fontSize: "16px",
                color: "rgb(92, 96, 102)",
                marginTop: "12px",
              }}
            >
              * Search for part number and click Send RFQ. RFQ Cart allows you
              to get quotes of multiple parts at the same time.
            </p>
          </Box>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              moveMarketPlace();
            }}
            style={{
              textAlign: "center",
            }}
            className="goto_marketplacestore"
          >
            Explore
          </a>
        </Box>
      </Box>
    </BaseLayout>
  );
}
